export default () => ({
    psychologitsArray: JSON.parse(sessionStorage.getItem('matching-psychologits')) || null,
    psychologits: null
})